import React, { useMemo } from 'react';

import * as Sentry from '@sentry/react';
import { getEmptyNotValidFields } from 'apps/auth/components/form-multi/utils';
import CurrentFieldsScreen from 'apps/auth/components/profile/CurrentFieldsScreen';
import BasePage from 'apps/auth/components/utils/BasePage';
import { PROFILE_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { logWarn } from 'apps/auth/helpers/clientLogger';
import { useExtra } from 'apps/auth/hooks/selectors';

const getEmptyFieldsGroup = (fields, headlines = {}) => {
    try {
        if (fields && Array.isArray(fields) && fields.length > 0) {
            return fields.reduce(
                (acc, group, index) => {
                    const errors = getEmptyNotValidFields(group);
                    if (errors?.length > 0) {
                        acc.extraFields.push(group);
                        acc.titleArr.push(headlines[index]);
                    }
                    return acc;
                },
                { extraFields: [], titleArr: [] },
            );
        }
        return [];
    } catch (e) {
        Sentry.captureException(e, {
            level: 'log',
        });
        logWarn(e);
        return [];
    }
};
const ProfileFieldsUpdatePage = () => {
    const { phoneCountry, profileFieldsGroups, headlines } = useExtra();
    const { extraFields, titleArr } = useMemo(() => getEmptyFieldsGroup(profileFieldsGroups, headlines), [headlines, profileFieldsGroups]);
    return (
        <CurrentFieldsScreen
            formName={PROFILE_FORM_NAME}
            phoneCountry={phoneCountry}
            action="/auth/profile/fields/save.action"
            location={AUTH_SEND_MAIN_LINK}
            extraFields={extraFields}
            validationFunc={getEmptyNotValidFields}
            titleArr={titleArr}
        />
    );
};
export default BasePage(ProfileFieldsUpdatePage);
